import React from "react";
import { Box, Chip, Grid, IconButton, Paper, Typography } from "@mui/material";
import PermIdentityOutlinedIcon from "@mui/icons-material/PermIdentityOutlined";
import { Link as RouterLink } from "react-router-dom";
import { formatPhoneNumber } from "../../common/util";
import LoyaltyStatus from "../../common/component/LoyaltyStatus";

/**
 * Order page widget: customer name, commercial/loyalty, contact, link to profile.
 */
export default function Customer({ customer, options }) {
  const { linkToProfile = true } = options;

  if (!customer) {
    return null;
  }

  return (
    <Box my={4}>
      <Grid container spacing={1} sx={{ alignItems: "center" }}>
        <Grid item xs>
          <Typography variant="overline" color="textSecondary">
            Customer
          </Typography>
        </Grid>
        {customer.id && linkToProfile && (
          <Grid item>
            <IconButton
              component={RouterLink}
              to={`/customer/${customer.id}`}
              aria-label="View customer profile"
              size="small"
              edge="end"
            >
              <PermIdentityOutlinedIcon />
            </IconButton>
          </Grid>
        )}
      </Grid>
      <Paper elevation={0}>
        <Box px={2} py={2}>
          <Typography variant="h4" sx={{ fontWeight: 600 }}>
            {`${customer.firstName || ""} ${customer.lastName || ""}`.trim() ||
              customer.name ||
              "—"}
            {customer.type === "commercial" ? (
              <Chip size="small" label="commercial" color="info" />
            ) : (
              customer?.loyaltyLevel && <LoyaltyStatus status={customer.loyaltyLevel} />
            )}
          </Typography>

          {customer?.phone && (
            <Typography variant="body2" color="textSecondary" display="block">
              {formatPhoneNumber(customer.phone)}
            </Typography>
          )}
          {customer.email && (
            <Typography variant="body2" color="textSecondary" display="block">
              {customer.email}
            </Typography>
          )}
        </Box>
      </Paper>
    </Box>
  );
}
